import { useEffect, useState } from 'react'
import { api } from '@/lib/api'

export type CoverageStatus = 'checking' | 'available' | 'unavailable'

// Pinga l'endpoint di health della copertura a monte (Egon raggiungibile + autenticato).
// I widget di verifica copertura usano questo stato per disabilitarsi quando il servizio
// non è disponibile, invece di fallire con un 500. Ricontrolla periodicamente, così se il
// servizio torna su i widget si riattivano da soli.
export function useCoverageHealth(pollMs = 60_000): CoverageStatus {
  const [status, setStatus] = useState<CoverageStatus>('checking')

  useEffect(() => {
    let cancelled = false
    let timer: ReturnType<typeof setTimeout>

    const check = async () => {
      try {
        const { available } = await api.coverageHealth()
        if (!cancelled) setStatus(available ? 'available' : 'unavailable')
      } catch {
        if (!cancelled) setStatus('unavailable')
      } finally {
        if (!cancelled) timer = setTimeout(check, pollMs)
      }
    }
    check()

    return () => {
      cancelled = true
      clearTimeout(timer)
    }
  }, [pollMs])

  return status
}
